function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false
  if (event.type.includes('shopify:section')) {
    if (
      domElement.hasAttribute('data-section-id') &&
      domElement.getAttribute('data-section-id') === event.detail.sectionId
    )
      executeCallback = true
  } else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true
  }
  if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver(entries => {
    entries.forEach(entry => callback(entry))
  }, options).observe(document.querySelector(elem))
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg)
}
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement)

  if (element) {
    let elementHeight = element.offsetHeight
    document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`)
  }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => {
  const roundedVh = Math.round(window.innerHeight * 0.01)
  document.body.style.setProperty('--vh', `${roundedVh}px`)
}
window.addEventListener('resize', getSetVh)

// Browser check
function getNavigator() {
  const isiOS =
    navigator.userAgent.match(/(iPhone|iPad|iPod)/) &&
    navigator.userAgent.match(/AppleWebKit/) &&
    !navigator.userAgent.match(/CriOS/)
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 ||
    (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)
  const isChrome =
    (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    navigator.userAgent.indexOf('Chrome') != -1
  const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1
  const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

  if (isiOS) document.documentElement.classList.add('ios')
  if (isSafari) document.documentElement.classList.add('safari')
  if (isChrome) document.documentElement.classList.add('chrome')
  if (isFirefox) document.documentElement.classList.add('firefox')
  if (isEdge) document.documentElement.classList.add('edge')
}

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
}
// Menu
let toggleMenu = function () {
  toggleClass('.fire-menu, .shrink-menu', 'open-menu')
}

function initializeDetailsControls() {
  // Handle dropdown menu
  const detailsElementsLv1 = document.querySelectorAll('details.lv1')
  const detailsElementsClosex = [...document.querySelectorAll('details.closex')]

  function closeOtherDetails(element) {
    const detailsOpened = document.querySelectorAll('details[open].lv1')
    for (const item of detailsOpened) {
      if (element !== item) {
        item.removeAttribute('open')
      }
    }
  }

  function closeAllDetailsExcept(target) {
    detailsElementsClosex.forEach(f => (!f.contains(target) ? f.removeAttribute('open') : ''))
    a11yDetails()
  }

  function closeAllDetails() {
    detailsElementsClosex.forEach(f => f.removeAttribute('open'))
    a11yDetails()
  }

  // Dropdown menu
  detailsElementsLv1.forEach(item => {
    item.addEventListener('click', function () {
      closeOtherDetails(this)
    })
  })

  // Close details when clicked outside
  document.addEventListener('click', function (e) {
    if (!detailsElementsClosex.some(f => f.contains(e.target))) {
      closeAllDetails()
    } else {
      closeAllDetailsExcept(e.target)
    }
  })

  // Close details with esc key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeAllDetails()
    }
  })

  // Initial accessibility settings
  a11yDetails()
}

function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id)
    }

    summary.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    })
  })
}

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute('data-price')
  var pb = document.querySelector('.uprice' + idd)
  pb.innerHTML = uid
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd)
}

// Debug
if (window.location.href.indexOf('debug') > -1) {
  var OpenThinking = OpenThinking || {}
  OpenThinking.theme = { name: 'Bullet', version: `${window.BOOMR.themeVersion}` }
  console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`)
}

// Bullet marquee
if (!customElements.get('bullet-marquee'))
  customElements.define(
    'bullet-marquee',
    class bulletMarquee extends HTMLElement {
      constructor() {
        super()
        if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this)
      }

      duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5)
        const contentWidth = entries[0].contentRect.width

        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375)

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (
          (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth) /
          contentWidth
        ).toFixed(3)

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`)
      }
    }
  )

/*** init app */
function app() {
  getSetVh() // get Viewport Height
  getNavigator() // get the browser + OS
  toggleMenu() // toggle Menu
  initializeDetailsControls() // call details
}

/*** on DOM ready **/
document.addEventListener('DOMContentLoaded', () => {
  app()
})

document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('addon-product')?.addEventListener('click', function () {
    var xhrClear = new XMLHttpRequest()
    xhrClear.open('POST', '/cart/clear.js', true)
    xhrClear.setRequestHeader('Content-Type', 'application/json')
    xhrClear.onreadystatechange = function () {
      if (xhrClear.readyState === 4 && xhrClear.status === 200) {
        preview_product()
      } else if (xhrClear.readyState === 4) {
        console.error('Clear cart error:', xhrClear.statusText)
      }
    }
    xhrClear.send()
  })

  function preview_product() {
    console.log('Clicked')
    var productId = document.getElementById('addon-product').getAttribute('data-value') // Get the product ID

    console.log('Quantity:', productId) // Debugging: Log the quantity

    // Data to send in the AJAX request
    var data = JSON.stringify({
      items: [
        {
          id: productId,
          quantity: 1
        }
      ]
    })

    console.log('Sending data:', data) // Debugging: Log the data being sent

    var xhrAdd = new XMLHttpRequest()
    xhrAdd.open('POST', '/cart/add.js', true)
    xhrAdd.setRequestHeader('Content-Type', 'application/json')
    xhrAdd.onreadystatechange = function () {
      if (xhrAdd.readyState === 4 && xhrAdd.status === 200) {
        console.log('Cart updated:', JSON.parse(xhrAdd.responseText))
        // Optionally update cart display here
        openDialogue()
      } else if (xhrAdd.readyState === 4) {
        console.error('Cart update error:', xhrAdd.statusText)
      }
    }
    xhrAdd.send(data)
  }

  function openDialogue() {
    var dialogElement = document.querySelector('dialog') // Assuming there's only one dialog element
    if (dialogElement && !dialogElement.hasAttribute('open')) {
      document.body.classList.add(`o-${dialogElement.id}`) // Optional: Add current dialog id as class to body
      dialogElement.setAttribute('open', 'true') // Add the 'open' attribute to show the dialog
      dialogElement.showModal() // Display the dialog
      dialogElement.setAttribute('aria-hidden', 'false') // Update accessibility attribute
    }
  }
})

function getCartProducts(callback) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var cartProducts = data.items.map(item => {
        return {
          id: item.id,
          product_id: item.product_id,
          quantity: item.quantity,
          title: item.title
        };
      });
      callback(cartProducts);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      callback([]);
    });
}

function updateCheckboxesState() {
  const checkboxes = document.querySelectorAll('.product-checkbox');
  const checkedCheckboxes = Array.from(checkboxes).filter(cb => cb.checked);

  if (checkedCheckboxes.length >= 2) {
    checkboxes.forEach(cb => {
      if (!cb.checked) {
        cb.disabled = true;
      }
    });
  } else {
    checkboxes.forEach(cb => (cb.disabled = false));
  }
}
function addToCart(variantId, quantity = 1, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    if (callback) callback(); // Call the callback to reload the cart
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}

function removeFromCart(variantId, callback) {
  getCartProducts(cartProducts => {
    const item = cartProducts.find(product => product.id == variantId);
    if (item) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(data => {
        if (callback) callback(); // Call the callback to reload the cart
      })
      .catch(error => {
        console.error('Error removing from cart:', error);
      });
    }
  });
}

function injectSampleProducts(cartProducts) {
  var has50MLProduct = cartProducts.some(function (item) {
    return item.title.includes('50 ML');
  });

  if (!has50MLProduct) {
    clearCart();
    return;
  }

  // let checkedSampleProduct = Array.from(document.querySelectorAll('.product-checkbox:checked'));

  var wrapper = document.createElement('div');
  wrapper.classList.add('sample-products-wrapper');

  var header = document.createElement('h5');
  header.innerHTML = `<span class="heading__text">Choose your 2 complimentary samples.</span><span class="heading__count" id="heading__count">0/2</span>`;
  wrapper.appendChild(header);

  var productsDiv = document.createElement('div');
  productsDiv.classList.add('sample-products');

  window.sampleProducts.forEach(function (product, index) {
    var itemDiv = document.createElement('div');
    itemDiv.classList.add('sp-item');

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'sp_' + (index + 1);
    checkbox.name = 'sample_product';
    checkbox.value = product.id;
    checkbox.classList.add('product-checkbox');

    // Check if this sample product is already in the cart
    var isInCart = cartProducts.some(function (cartProduct) {
      return cartProduct.id == product.id;
    });

    // If the product is in the cart, keep it checked
    if (isInCart) {
      checkbox.checked = true;
    }

    // Add event listener for change event to add/remove product from cart
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        addToCart(product.id, 1, reloadCoretexCart); // Pass the reload function as a callback
      } else {
        removeFromCart(product.id, reloadCoretexCart); // Pass the reload function as a callback
      }
      updateCheckboxesState();
    });

    var label = document.createElement('label');
    label.setAttribute('for', 'sp_' + (index + 1));

    var imgDiv = document.createElement('div');
    imgDiv.classList.add('sp-image');

    var img = document.createElement('img');
    img.src = product.image;
    img.alt = product.alt;

    var titleP = document.createElement('p');
    titleP.classList.add('sp-title');
    titleP.innerText = product.title;

    imgDiv.appendChild(img);
    label.appendChild(imgDiv);
    label.appendChild(titleP);

    itemDiv.appendChild(checkbox);
    itemDiv.appendChild(label);
    productsDiv.appendChild(itemDiv);
  });

  wrapper.appendChild(productsDiv);

  var cartElement = document.querySelector('#sampleProductsDiv');
  if (cartElement) {
    cartElement.appendChild(wrapper);
  }

  updateCheckboxesState();
}
function clearCart() {
  const cartItems = document.querySelectorAll(`.cart-item`);
  const sampleCartItems = [];

  cartItems.forEach(cartItem => {
    if (cartItem.textContent.includes("FREE SAMPLE")) {
      cartItem.classList.add('removing');
      sampleCartItems.push(cartItem);
    }
  });

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const has50MLProduct = cart.items.some(item => item.title.includes('50 ML'));
      const has15MLProduct = cart.items.some(item => item.title.includes('15 ML'));
      // ✅ Target the sample products container
      const sampleDiv = document.querySelector('#sampleProductsDiv');

      if (!sampleDiv) return false;

      // If no 50 ML product, inject message and remove samples
      if (!has50MLProduct) {
        // Clear existing content
         if (has15MLProduct && !has50MLProduct) {
        document.querySelector('.coretex-cart .accordion').classList.remove('no-product');
           
        sampleDiv.innerHTML = `
          <div class="sample-message">
            <p>Upgrade to a <strong>50ml</strong> to unlock free samples! </p>
          </div>
        `;
         }
        else{
       document.querySelector('.coretex-cart .accordion').classList.add("no-product");
        }
        // Also remove Free Samples from cart
        const updates = {};
        cart.items.forEach(item => {
          if (item.title.includes("FREE SAMPLE")) {
            updates[item.id] = 0;
          }
        });

        if (Object.keys(updates).length === 0) return false;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        }).then(() => true);
      } else {
        // ✅ If 50 ML is in cart, clear message so samples can render
        if (sampleDiv.querySelector('.sample-message')) {
          sampleDiv.querySelector('.sample-message').remove();
        }
      }

      return false;
    })
    .then(shouldReload => {
      if (shouldReload) {
        setTimeout(() => {
          reloadCoretexCart();
        }, 200);
      }
    })
    .catch(error => {
      console.error('Error removing Free Sample products:', error);
    });
}




function reloadCoretexCart() {
  // Fetch the updated cart HTML
  fetch('/cart')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace coretex-cart content
      const updatedCart = doc.querySelector('coretex-cart');
      const coretexCartElement = document.querySelector('coretex-cart');
      if (updatedCart && coretexCartElement) {
        coretexCartElement.innerHTML = updatedCart.innerHTML;
      }

      // ✅ Update all elements with data-count (no need for specific bind)
      const updatedCountElement = doc.querySelector('[data-count]');
      const newCount = updatedCountElement?.getAttribute('data-count') || updatedCountElement?.textContent?.trim();

      if (newCount !== undefined) {
        const countTargets = document.querySelectorAll('[data-count]');
        countTargets.forEach(el => {
          el.setAttribute('data-count', newCount);
        });
      }

      // Continue other updates
      getCartProducts(injectSampleProducts);
      updateCartItemClasses();
    })
    .catch(error => {
      console.error('Error reloading coretex-cart:', error);
    });
}



function updateCartItemClasses() {
  getCartProducts(cartProducts => {
    // Get all cart items
    const cartItems = document.querySelectorAll('.cart-item');

    // Get IDs of checked sample products
    let checkedSampleProductI = document.querySelectorAll('.product-checkbox:checked');
    let Heading = document.querySelector('#sampleProductsDiv h5');
    Heading.innerHTML = `<span class="heading__text">Choose your 2 complimentary samples.</span><span class="heading__count" id="heading__count">${checkedSampleProductI.length}/2</span>`;
    const checkedSampleProductIds = Array.from(document.querySelectorAll('.product-checkbox:checked'))
      .map(cb => cb.value);

    // Loop through each cart item
    cartItems.forEach(cartItem => {
      const itemId = cartItem.getAttribute('cart-item-id'); // Assuming you store the cart item ID in a data attribute

      // Check if the cart item ID is in the list of checked sample product IDs
      if (checkedSampleProductIds.includes(itemId)) {
        cartItem.classList.add('sample-product');
      } else {
        cartItem.classList.remove('sample-product');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  updateCartItemClasses();
});


var fifteen_ml_url = new URL(window.location.href);

// Get the 'size' query parameter
var sizeParam = fifteen_ml_url.searchParams.get("filter.v.option.size");

// Check if the size is '15 ML'
if (sizeParam === "15 ML") {
  // Select the elements and change the opacity
  document.querySelectorAll('.product .cards .card-image .secondary').forEach(function(element) {
    element.style.opacity = '1';
  });
}
